import {AnswerStatus, QuestionDifficulty} from './scoring.types'

export interface QuestionDto {
  id: string
  difficulty: QuestionDifficulty
  submission?: {
    answer: AnswerStatus
  }
}

export const QUESTION_DIFFICULTIES: QuestionDifficulty[] = [
  QuestionDifficulty.Basic,
  QuestionDifficulty.Advanced,
  QuestionDifficulty.Excellence
]

export const QUESTION_CATEGORIES_LIST: QuestionDifficulty[] = Object.values(QuestionDifficulty)
